import { DEFAULT_CURRENCY_CODE, Provider } from '@angular/core';
import { AppLocaleService } from '../services/locale.service';

export class AppCurrencyCode extends String {
  constructor(private localeService: AppLocaleService) {
    super();
  }

  override toString(): string {
    return this.localeService.currency;
  }

  override valueOf(): string {
    return this.toString();
  }
}

/** Provider custom per il currency, realizzato per permettere il cambio del locale senza forzare il reload dell'applicazione Ref: https://angular-dynamic-locale-4ld5c2jq.stackblitz.io */
export const AppCurrencyProvider: Provider = {
  provide: DEFAULT_CURRENCY_CODE,
  useClass: AppCurrencyCode,
  deps: [AppLocaleService]
};
